import logger from "../../../logging/logger";

export const transformErrors = (errors) => {
  return errors.map((error) => {
    logger.error("err:", error);
    if (error.name === "minItems" && error.property === ".to.taetigkeit") {
      error.message = `Es muss mindestens ${error.params.limit} Bereich ausgewählt sein.`;
    }
    if(error.name === "oneOf"){
        error.message = ''
    }
    return error;
  });
};

export let bereichExamination = {
  label: "Untersuchung steht an in Bereich",
  desc: "Benachrichtigung an Vorgesetzte von Tätigkeitsbereichen, wenn Untersuchungen für Mitarbeiter in ihrem Bereich anstehen",
  form_schema: {
    definitions: {
      taetigkeit: {
        title: "für welchen Tätigkeitsbereich",
        minItems: 1,
        type: "array",
        uniqueItems: true,
        description:
          "Nur ausgewählte Tätigkeitsbereiche werden geprüft, es wird nicht geprüft ob eine E-Mail Hinterlegt ist.",
        items: {
          anyOf: [],
        },
      },
      Begrenzung: {
        type: "object",
        title: "Begrenzung",
        properties: {
          taetigkeit: { $ref: "#/definitions/taetigkeit" },
        },
        required: ["taetigkeit"],
      },
    },
    type: "object",
    required: ["to", "when"],
    properties: {
      cron: {
        title: "In welchem Intervall soll die E-Mail gesendet werden?",
        type: "string",
        description:
          "CRON Zeiteinstellung ( https://crontab.guru/ ) DEFAULT = '00 04 1 * *'",
        default: "00 04 1 * *",
      },
      from: {
        type: "string",
        title: "Sender E-Mail",
        default: "info@divoka.de",
      },
      to: {
        type: "object",
        title: "Empfänger",
        oneOf: [
          {
            title: "Vorgesetzte",
            type: "object",
            required: ["type", "Begrenzung"],
            properties: {
              type: {
                type: "string",
                enum: ["vorgesetzte"],
                default: "vorgesetzte"
              },
              email: {
                type: "string",
                title: "E-Mail Adresse",
                "default": "E-Mail geht an die im Bereich konfigurierte Vorgesetzten-E-Mail",
                readOnly: true,
              },
              Begrenzung: { $ref: "#/definitions/Begrenzung" },
            },
          },
          {
            title: "Individuell",
            type: "object",
            required: ["type", "email", "Begrenzung"],
            properties: {
              type: {
                type: "string",
                enum: ["individuell"],
                default: "individuell"
              },
              email: {
                type: "string",
                title: "E-Mail Adresse",
              },
              Begrenzung: { $ref: "#/definitions/Begrenzung" },
            },
          },
        ],
      },
      when: {
        title: "Welcher Zeitraum soll beachtet werden?",
        type: "object",
        properties: {
          zahl: {
            title: "x vor Ablauf",
            type: "number",
            description:
              "Ablauf ist das Datum wann die Untersuchung nicht mehr Gültig ist.",
          },
          auswahl: {
            title: "Tage/Monate",
            type: "string",
            enum: ["Tage", "Monate"],
          },
        },
        required: ["zahl", "auswahl"],
      },
      subject: {
        type: "string",
        title: "Betreff",
      },
      text: {
        type: "string",
        title: "E-Mail Text",
      },
    },
  },
  uiSchema: {
    text: {
      "ui:widget": "textarea",
      "ui:options": {
        rows: 8,
      },
    },
    subject: {
      "ui:help": "- {bereichname}: Für den Namen des Bereichs"
    },
    readonly: {
      "ui:readonly": true,
    },
    cron: {
      "ui:help": "Um 04:00, an Tag 1 des Monats",
    },
    to: {
      "ui:classNames": "si-oneOf",
      vorgesetzte: {
        email: {},
      },
      type: {
        "ui:widget": "hidden"
      },
    },
  },
  function: trigger,
  transformErrors: transformErrors,
  mail_context: (content) => {
    const isVorgesetzte = content?.to?.type === "vorgesetzte";
    if (isVorgesetzte) {
      return ["{bereichname}", "{ma-list}"];
    }
    // Individueller Empfänger: bei diesem Trigger keine Platzhalter-Ersetzung
    return [];
  },
  context_functions: () => [],
};

export function trigger() {
  logger.log("bereichExamination Trigger!!!!");
}
